import { ExternalLink } from 'lucide-react';
import { Layout } from '@/components/Layout';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CHANGELOG, VERSION } from '@/lib/version';

/** Renders the full version history from lib/version.ts. */
export default function ChangelogPage() {
  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-3 sm:px-6 py-8">
        <h1 className="text-2xl font-bold">Changelog</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          VidStr version history. Current version:{' '}
          <Badge variant="secondary" className="font-mono">v{VERSION}</Badge>
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          This changelog covers the VidStr rebuild. Looking for the old VidStr?{' '}
          <a
            href="https://47h1rs70oqaspur8bichfzalg0wnassb8d7tslfacl7hwyaxhkvidstr.nsite.lol"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-primary hover:underline"
          >
            Visit the original VidStr
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </p>

        <div className="mt-6 space-y-4">
          {CHANGELOG.map((entry) => (
            <Card key={entry.version}>
              <CardHeader className="pb-3">
                <CardTitle className="flex flex-wrap items-center gap-2 text-base">
                  <Badge variant="outline" className="font-mono">v{entry.version}</Badge>
                  <span className="text-xs font-normal text-muted-foreground">{entry.date}</span>
                </CardTitle>
                <p className="text-sm font-medium">{entry.title}</p>
              </CardHeader>
              <CardContent>
                <ul className="list-disc space-y-1.5 pl-5 text-sm text-muted-foreground">
                  {entry.changes.map((change, i) => (
                    <li key={i} className="leading-relaxed">{change}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
}
